import getCookies from '../../utils/getCookies.js'
import setCookies from '../../utils/setCookies.js'

export default
{
    watch:
    {
        $route: 'onRouteChange'
    },

    data()
    {
        return {
            randomInt: 0,
            isBtnBackVisible: false,
            from: null
        }
    },

    created()
    {
        this._isSelectionFormActive = false

        this.eventHub.$on('selection:openForm', this.onSelectionFormOpen)
    },

    mounted()
    {
        this.initLogo()
    },

    methods:
    {
        initLogo()
        {
            const $logo = this.$el.querySelector('.js-logo')
            const nbLogo = this.$root.globalContent.settings.logos.length



            if(getCookies('randomLogoIndex'))
            {
                if(nbLogo > 1)
                {
                    this.randomInt = this.getRandomInt(0, nbLogo, +getCookies('randomLogoIndex'))
                }
                else
                {
                    this.randomInt = this.getRandomInt(0, nbLogo)
                }
            }
            else
            {
                this.randomInt = this.getRandomInt(0, nbLogo)
            }

            // store the current logo index to exclude it on next visit (to don't have the same logo on 2 visite/refresh)
            setCookies('randomLogoIndex', this.randomInt, 10)

            const img = new Image()

            img.onload = (() =>
            {
                $logo.src = img.src
            })

            img.src = this.$root.globalContent.settings.logos[this.randomInt].logo.url
        },

        onResetFilters()
        {
            // if(this.$root.isMagmaFiltered)
            // {
            //     this.eventHub.$emit('filters:reset')
            // }

            this.eventHub.$emit('filters:reset')
        },

        getRandomInt(min, max, exept)
        {
            const random = Math.floor(Math.random() * max) + min
            return random === exept ? this.getRandomInt(min, max, exept) : random
        },

        onRouteChange(to, from)
        {
            if(from)
            {
                this.from = from
                this.isBtnBackVisible = true
            }
            else
            {
               this.isBtnBackVisible = false
            }

            this._isSelectionFormActive = false
            this.$el.classList.remove('is-selection-form-active')
        },

        onSelectionFormOpen()
        {
            this._isSelectionFormActive = true
            this.$el.classList.add('is-selection-form-active')
        },

        onBack()
        {
            if(!this._isSelectionFormActive)
            {
                this.$router.go(-1)
            }
            else
            {
              this.eventHub.$emit('selection:closeForm')
              this._isSelectionFormActive = false
              this.$el.classList.remove('is-selection-form-active')
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-logo/script.js